<template>
  <div class="w-full h-full">
    <AppTodo/>
  </div>
</template>

<script>
import AppTodo from "@/components/AppTodo";

export default {
  name: 'App',
  components: {
    AppTodo,
  }
}
</script>
